/**
 * @fileoverview gRPC-Web generated client stub for com.livongo.protobuf.grpc.external.coaching
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.23.1
// source: livongo/protobuf/grpc/external/coaching/coaching.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.com = {};
proto.com.livongo = {};
proto.com.livongo.protobuf = {};
proto.com.livongo.protobuf.grpc = {};
proto.com.livongo.protobuf.grpc.external = {};
proto.com.livongo.protobuf.grpc.external.coaching = require('./coaching_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo>}
 */
const methodDescriptor_DPPCoachingManager_GetUserPredictReportable = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetUserPredictReportable',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerClient.prototype.getUserPredictReportable =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetUserPredictReportable',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetUserPredictReportable,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerPromiseClient.prototype.getUserPredictReportable =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetUserPredictReportable',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetUserPredictReportable);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse>}
 */
const methodDescriptor_DPPCoachingManager_GetLatestPredictedUTC = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetLatestPredictedUTC',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerClient.prototype.getLatestPredictedUTC =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetLatestPredictedUTC',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetLatestPredictedUTC,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerPromiseClient.prototype.getLatestPredictedUTC =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetLatestPredictedUTC',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetLatestPredictedUTC);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse>}
 */
const methodDescriptor_DPPCoachingManager_GetMemberAssignedCoach = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetMemberAssignedCoach',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerClient.prototype.getMemberAssignedCoach =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetMemberAssignedCoach',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetMemberAssignedCoach,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerPromiseClient.prototype.getMemberAssignedCoach =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/GetMemberAssignedCoach',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_GetMemberAssignedCoach);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse>}
 */
const methodDescriptor_DPPCoachingManager_MarkCoachViewed = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/MarkCoachViewed',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerClient.prototype.markCoachViewed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/MarkCoachViewed',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_MarkCoachViewed,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.DPPCoachingManagerPromiseClient.prototype.markCoachViewed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.DPPCoachingManager/MarkCoachViewed',
      request,
      metadata || {},
      methodDescriptor_DPPCoachingManager_MarkCoachViewed);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse>}
 */
const methodDescriptor_CoachingSessionManager_ListCoachingSessions = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListCoachingSessions',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerClient.prototype.listCoachingSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListCoachingSessions',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_ListCoachingSessions,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerPromiseClient.prototype.listCoachingSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListCoachingSessions',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_ListCoachingSessions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse>}
 */
const methodDescriptor_CoachingSessionManager_GetCoachingSessionDetails = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetCoachingSessionDetails',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerClient.prototype.getCoachingSessionDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetCoachingSessionDetails',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_GetCoachingSessionDetails,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerPromiseClient.prototype.getCoachingSessionDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetCoachingSessionDetails',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_GetCoachingSessionDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse>}
 */
const methodDescriptor_CoachingSessionManager_ListMemberGoals = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListMemberGoals',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerClient.prototype.listMemberGoals =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListMemberGoals',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_ListMemberGoals,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerPromiseClient.prototype.listMemberGoals =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/ListMemberGoals',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_ListMemberGoals);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse>}
 */
const methodDescriptor_CoachingSessionManager_GetMemberUpcomingSessions = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetMemberUpcomingSessions',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerClient.prototype.getMemberUpcomingSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetMemberUpcomingSessions',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_GetMemberUpcomingSessions,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionManagerPromiseClient.prototype.getMemberUpcomingSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingSessionManager/GetMemberUpcomingSessions',
      request,
      metadata || {},
      methodDescriptor_CoachingSessionManager_GetMemberUpcomingSessions);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>}
 */
const methodDescriptor_CoachingStatusManager_GetCoachingStatus = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/GetCoachingStatus',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerClient.prototype.getCoachingStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/GetCoachingStatus',
      request,
      metadata || {},
      methodDescriptor_CoachingStatusManager_GetCoachingStatus,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerPromiseClient.prototype.getCoachingStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/GetCoachingStatus',
      request,
      metadata || {},
      methodDescriptor_CoachingStatusManager_GetCoachingStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest,
 *   !proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>}
 */
const methodDescriptor_CoachingStatusManager_UpdateCoachingStatus = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/UpdateCoachingStatus',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest,
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerClient.prototype.updateCoachingStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/UpdateCoachingStatus',
      request,
      metadata || {},
      methodDescriptor_CoachingStatusManager_UpdateCoachingStatus,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingStatusManagerPromiseClient.prototype.updateCoachingStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.coaching.CoachingStatusManager/UpdateCoachingStatus',
      request,
      metadata || {},
      methodDescriptor_CoachingStatusManager_UpdateCoachingStatus);
};


module.exports = proto.com.livongo.protobuf.grpc.external.coaching;

